var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaticon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.9978,
    height: 41.9978,
    fill: "#D4AF37",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 41.4978,
    height: 41.4978,
    stroke: "#C9B99B",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0618 21.3469C10.9785 21.1224 10.9785 20.8755 11.0618 20.651C11.8735 18.683 13.2511 17.0003 15.0202 15.8163C16.7893 14.6323 18.8702 14.0002 20.9989 14.0002C23.1277 14.0002 25.2085 14.6323 26.9776 15.8163C28.7467 17.0003 30.1244 18.683 30.936 20.651C31.0193 20.8755 31.0193 21.1224 30.936 21.3469C30.1244 23.3149 28.7467 24.9975 26.9776 26.1816C25.2085 27.3656 23.1277 27.9977 20.9989 27.9977C18.8702 27.9977 16.7893 27.3656 15.0202 26.1816C13.2511 24.9975 11.8735 23.3149 11.0618 21.3469Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9991 23.9991C22.656 23.9991 23.9991 22.656 23.9991 20.9991C23.9991 19.3423 22.656 17.9991 20.9991 17.9991C19.3423 17.9991 17.9991 19.3423 17.9991 20.9991C17.9991 22.656 19.3423 23.9991 20.9991 23.9991Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticon01);
export default __webpack_public_path__ + "static/media/staticon01.dc4232adcb8e54e2b6db3265da82fed5.svg";
export { ForwardRef as ReactComponent };